export default __webpack_public_path__ + "static/media/pexels-ron-lach-7353185.b4fd968f.mp4";